import { render, staticRenderFns } from "./PalletInfo.vue?vue&type=template&id=257fd418&scoped=true"
import script from "./PalletInfo.vue?vue&type=script&lang=js"
export * from "./PalletInfo.vue?vue&type=script&lang=js"
import style0 from "./PalletInfo.vue?vue&type=style&index=0&id=257fd418&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257fd418",
  null
  
)

export default component.exports